<template>
  <div class="base-text-3" v-html="text"/>
</template>

<script>
export default {
  props: {
    text: {
      type: [String, Number],
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-3 {
  font-size: 2rem;
  line-height: 0.9em;
  letter-spacing: var(--letter-spacing);
  color: var(--color-white-1);
}
</style>
